export const BANK_ACCOUNT_ENDPOINTS = {
  LIST: '/api/bank-accounts',
  CREATE: '/api/bank-accounts',
  UPDATE: '/api/bank-accounts',
  UPLOAD_STATEMENT: '/api/bank-accounts/upload',
  // GET-by-id is the canonical primary-key path for fetching an
  // investor's own account (the LOOKUP-by-iban path needs an unmasked
  // IBAN the list doesn't return).
  DETAIL: '/api/bank-accounts/{id}',
  LOOKUP: '/api/bank-accounts/lookup',
  SET_PRIMARY: '/api/bank-accounts/{id}',
  // DELETE on the same primary-key path as DETAIL / SET_PRIMARY. Confirm
  // against Swagger before release — both openapi MCP servers were down when
  // this was written, so the verb is inferred from the module's own path
  // convention rather than read off the spec.
  DELETE: '/api/bank-accounts/{id}',
} as const
